import React from 'react';
import {
  MarketingLayout,
  Section,
  Hero,
  PricingTable,
  CallToAction,
} from '@byscott-io/corebyscott';

// TODO: In the future, fetch this from billingbyscott via useBilling() hook
const pricingTiers = [
  {
    name: 'Free',
    price: '$0',
    period: '/month',
    description: 'Perfect for single families just getting started.',
    features: [
      'Up to 3 students',
      'Pre-K Readiness assessment',
      'Basic progress tracking',
      'Life skills checklists',
      'Email support',
    ],
    cta: { label: 'Get Started', href: '/register' },
    highlighted: false,
  },
  {
    name: 'Family',
    price: '$9',
    period: '/month',
    description: 'For growing families who want complete assessment tools.',
    features: [
      'Unlimited students',
      'All Pre-K through Grade 8 assessments',
      'Learning differences screening',
      'Complete life skills tracking',
      'Year-over-year progress reports',
      'Exportable portfolios',
      'Priority support',
    ],
    cta: { label: 'Start Free Trial', href: '/register' },
    highlighted: true,
  },
  {
    name: 'Co-op',
    price: '$49',
    period: '/month',
    description: 'For homeschool co-ops and small schools.',
    features: [
      'Everything in Family',
      'Up to 20 families',
      'Multiple administrator accounts',
      'Teacher group assignments',
      'Aggregate reporting',
      'Co-op dashboard',
      'Phone support',
    ],
    cta: { label: 'Start Free Trial', href: '/register' },
    highlighted: false,
  },
];

export default function PricingPage() {
  return (
    <MarketingLayout>
      <Hero
        headline="Simple, Transparent Pricing"
        subheadline="Choose the plan that's right for your family or co-op. No hidden fees, no surprises."
        background="gray"
        layout="centered"
      />

      <Section background="white" padding="xl">
        <PricingTable
          tiers={pricingTiers}
          title="Plans for every family size"
          subtitle="All plans include a 14-day free trial. No credit card required."
        />
      </Section>

      <Section background="gray">
        <div className="mx-auto max-w-3xl">
          <h2 className="text-center text-2xl font-bold text-gray-900">
            Frequently Asked Questions
          </h2>
          <dl className="mt-10 space-y-8">
            <div>
              <dt className="text-lg font-semibold text-gray-900">
                Can I try LifeSkillsPath before committing?
              </dt>
              <dd className="mt-2 text-gray-600">
                Yes! All plans come with a 14-day free trial. No credit card required. If you decide it's not for you, just don't subscribe - no questions asked.
              </dd>
            </div>
            <div>
              <dt className="text-lg font-semibold text-gray-900">
                What ages are the assessments designed for?
              </dt>
              <dd className="mt-2 text-gray-600">
                Our assessments cover Pre-K through high school. Pre-K Readiness is available in all plans. K-8 Academic Assessments are included in Family and Co-op plans. High school assessments are coming soon.
              </dd>
            </div>
            <div>
              <dt className="text-lg font-semibold text-gray-900">
                Can I switch plans later?
              </dt>
              <dd className="mt-2 text-gray-600">
                Absolutely. You can upgrade or downgrade your plan at any time. Changes take effect at your next billing cycle.
              </dd>
            </div>
            <div>
              <dt className="text-lg font-semibold text-gray-900">
                Is my data secure?
              </dt>
              <dd className="mt-2 text-gray-600">
                Yes. We use industry-standard encryption for all data in transit and at rest. Your family's information is always protected.
              </dd>
            </div>
            <div>
              <dt className="text-lg font-semibold text-gray-900">
                Are these assessments the same as standardized tests?
              </dt>
              <dd className="mt-2 text-gray-600">
                LifeSkillsPath assessments are designed for at-home administration and progress tracking. They are not official standardized tests but follow standard grade-level scope and sequence to help you understand where your students are academically.
              </dd>
            </div>
            <div>
              <dt className="text-lg font-semibold text-gray-900">
                Can I cancel anytime?
              </dt>
              <dd className="mt-2 text-gray-600">
                Yes, you can cancel your subscription at any time. You'll continue to have access until the end of your billing period.
              </dd>
            </div>
          </dl>
        </div>
      </Section>

      <CallToAction
        headline="Start tracking your students' growth today"
        description="Join families who trust LifeSkillsPath for academic assessment and life skills tracking."
        primaryCta={{ label: 'Start Free Trial', href: '/register' }}
        secondaryCta={{ label: 'Contact Sales', href: '/contact' }}
        background="primary"
      />
    </MarketingLayout>
  );
}
